<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/feMQGa/tc-custom/9781631951404.jpg?1737674837165" alt="This image is the cover for the book Take the First Shot, The Revolutionize Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Take the First Shot, The Revolutionize Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A career and personal development coach shows entrepreneurs how to improve their lives and the lives of others through simple strategies.</b><br/><br/>Most people would like to change some behavior patterns and create better outcomes in their personal and professional lives. The trouble is that thinking about making a change often feels overwhelming. It’s hard to know where to start.<br/><br/>That’s why Peggy Caruso wrote <i>Take the First Shot</i>. She is passionate about helping people fire up their lives and begin making positive changes. <i>Take the First Shot</i> provides a wealth of tools and techniques to help entrepreneurs take the first step to making a profound difference in their life and in others’ lives. Within <i>Take the First Shot</i>, Peggy provides simple strategies to help entrepreneurs:Improve their relationships and become a better parentEnhance their health and achieve personal development goalsBalance their career and family obligationsAchieve meaningful change and grow in love, gratitude, and strength<br/><br/><b>Praise for <i>Take the First Shot</i></b><br/><br/>“Peggy Caruso offers a treasure trove of small, practical, first steps you can take to revolutionize your life. Take one of her strategies and start creating a new future today!” —Jack Canfield, co-author of <i>The Success Principles </i>and<i> Chicken Soup for the Soul</i><br/><br/>“Peggy Caruso shows anyone how they can use the biggest problems they face to their advantage and truly transform their life. One small step is all it takes, and she gives you many possible ways to take that first step.” —Steve Harrison, co-founder of The National Publicity Summit<br/><br/>“Peggy is a wise leader. She’s a great career and personal development coach who has spent years studying human personality. You’ll begin acting on it, and that's when your life will truly be revolutionized.” —Bob Proctor, international bestselling author and star of <i>The Secret</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peggy Caruso
      </h2>
      
      <p class="authorDescription body article"><B>Peggy Caruso</B> is a certified executive and personal development coach, author of four books in the revolutionize series, host of “The Revolutionize Podcast”, 8-time entrepreneur, and a certified relaxation therapist. Peggy has been on ABC, NBC, CBS, Success Magazine, Reader’s Digest, and hundreds of radio and podcast shows. She currently resides in DuBois, PA.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?799ba01c